import { EmptyState } from '@/components/common';
import { routes } from '@/config/routes';
import type { ProductCardModel } from '@/features/catalog/api';

import { ProductCard } from './ProductCard';

export function ProductGrid({
  products,
  emptyTitle = 'No products match these filters',
}: {
  products: ProductCardModel[];
  emptyTitle?: string;
}) {
  if (products.length === 0) {
    return (
      <EmptyState
        title={emptyTitle}
        description="Try a broader search or clear a filter to see more personalized ideas."
        actionLabel="Browse all products"
        actionTo={routes.products}
      />
    );
  }

  return (
    <div className="product-grid">
      {products.map((product) => (
        <ProductCard key={product.id} product={product} />
      ))}
    </div>
  );
}
